<template>
	<div class="view-multi-format">
		<MultiFormatTool
			v-if="multiFormatAllowed"
			:event-id="eventId"
			:tag-time="tagTime"
			:default-graphic-set="defaultGraphicSet"
			:graphic-sets="graphicSets"
			:event-labels="eventLabels"
			:event-title="eventTitle"
			:is-community-cropping="isCommunityCropping"
		/>
		<div
			v-else
			class="view-multi-format__not-available"
		>
			{{ $I18n.trans('event.multiformat_editor.not_yet_available') }}
		</div>
	</div>
</template>

<script>
import MultiFormatTool from '@shared/components/MultiFormatTool/MultiFormatTool.vue';

export default {
	name:       'ViewMultiFormat',
	components: { MultiFormatTool },
	props:      {
		eventId: {
			type:     Number,
			required: true,
		},
		tagTime: {
			type:    Object,
			default: null,
		},
		videoAvailable: {
			type:    Boolean,
			default: false,
		},
		graphicSets: {
			type:    Array,
			default: () => [],
		},
		eventLabels: {
			type:    Array,
			default: () => [],
		},
		eventTitle: {
			type:    String,
			default: '',
		},
		defaultGraphicSet: {
			type:    Object,
			default: null,
		},
		isCommunityCropping: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		multiFormatAllowed() {
			return this.videoAvailable;
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.view-multi-format {
	height: 100%;
}

.view-multi-format__not-available {
	padding: $sp4;
	display: flex;
	align-items: center;
	justify-content: center;
}

</style>
